<cap-list-loader [hasRight]="hasRight" [listLoader]="listLoader" [showTotal]="false" [showZeilenSelect]="false">
  <div class="cap-list-loader-content">
    <table class="cap-table-detail">
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRowsBodenbedeckung"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>
<ng-template #tableRowsBodenbedeckung>
  @for (bodenbedeckung of listLoader?.items; track bodenbedeckung) {
    <tr>
      @if (bodenbedeckung.art === BodenbedeckungArtEnum.GEBAEUDE) {
        <td [capHistinfo]="bodenbedeckung.histInfo" style="width: 40%">
          <div>
            {{ bodenbedeckung.art | translate }}
          </div>
        </td>
        <td [capHistinfo]="bodenbedeckung.histInfo" style="width: 1%">
          <div class="text-end">{{ bodenbedeckung.flaecheQuadratmeter | decimalHochkomma }}&nbsp;m²</div>
        </td>
        <td>
          <cap-kompakt-timepoint [item]="bodenbedeckung.histInfo?.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
        </td>
      }
      @if (bodenbedeckung.art !== BodenbedeckungArtEnum.GEBAEUDE) {
        <td [capHistinfo]="bodenbedeckung.histInfo" style="width: 35%">
          <div>
            @if (bodenbedeckung.art || bodenbedeckung.bodenbedeckungArtZusatz) {
              <span>
                {{ bodenbedeckung.art | translate }}
                {{ bodenbedeckung.bodenbedeckungArtZusatz | translate }}
              </span>
            }
            @if (!bodenbedeckung.art && !bodenbedeckung.bodenbedeckungArtZusatz) {
              <span>
                {{ "UNBESTIMMT" | translate }}
              </span>
            }
          </div>
        </td>
        <td [capHistinfo]="bodenbedeckung.histInfo" style="width: 10%">
          <div class="text-end">{{ bodenbedeckung.flaecheQuadratmeter | decimalHochkomma }}&nbsp;m²</div>
        </td>
        <td>
          <cap-kompakt-timepoint [item]="bodenbedeckung.histInfo?.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
        </td>
      }
    </tr>
  }
</ng-template>
